import { DialogContent, DialogTitle } from "@/components/ui/dialog";

interface ImgPopProps {
    title: string;
    children: React.ReactNode;
}

export default function ImgPop({ title, children }: ImgPopProps) {
    return (
        <DialogContent className="w-[calc(100%-40px)] max-w-[700px] bg-[#F7F6FB] p-0 overflow-hidden gap-0 block rounded-[20px] [&>button]:z-[1] [&>button]:right-[30px] [&>button]:top-6 [&>button]:opacity-100 [&>button]:!ring-0 [&>button]:!ring-offset-0 [&>button>svg]:w-8 [&>button>svg]:h-8">
            <DialogTitle className="p-[24px_65px_16px_40px] border-b border-[#ddd] text-[24px] font-[700] relative z-[1]">
                {title}
            </DialogTitle>
            {children}
        </DialogContent>
    );
}
